import { Component, ComponentInterface, Element, h, Listen, Prop, State, Watch } from "@stencil/core";
import { getIconSetRegistry, IconSetIcon, parseIconFromName } from "../iconset/iconset-registry";

@Component({
    tag: "uic-icon",
    styleUrl: "icon.scss"
})
export class Icon implements ComponentInterface {
    @Element() host: HTMLUicIconElement;
    @State() src: string;

    /**
     * The name of the icon to show. Corresponds to an ID of a symbol inside an SVG sheet.
     */
    @Prop() name: string;

    /**
     * A convenient way to set a predefined icon size.
     */
    @Prop({ reflect: true }) size?: "small";

    @Watch("name")
    handleChange(name: string) {
        if (!name) {
            return;
        }

        const icon = parseIconFromName(name);
        this.updateIcon(icon);
    }

    connectedCallback() {
        this.handleChange(this.name);
    }

    @Listen("uicIconSetAdded", { target: "window" })
    handleIconSetAdded(event: CustomEvent<string>) {
        if (!this.name) {
            return;
        }

        const icon = parseIconFromName(this.name);
        if (event.detail === icon.iconSet) {
            this.updateIcon(icon);
        }
    }

    private updateIcon(icon: IconSetIcon) {
        this.src = getIconSetRegistry().resolveIconSrc(icon);

        const set = getIconSetRegistry().getSet(icon.iconSet);
        if (set) {
            if (set.mutator) {
                set.mutator(this.host.querySelector("svg"));
            }
        }
    }

    render() {
        return (
            <svg>
                <use href={this.src} xlinkHref={this.src} />
            </svg>
        );
    }
}
